import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError, switchMap, EMPTY } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../../environments/environment';
import { ConfigService } from './config.service';
import { MaintenanceService } from '../../_services/maintenance/maintenance.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  let request = req;
  const configService = inject(ConfigService);
  const maintenanceService = inject(MaintenanceService);
  const router = inject(Router);
  const config = configService.getConfig();

  // Skip maintenance check for non-POST requests and specific URLs
  if (
    req.method !== 'POST' ||
    (request.url && request.url.includes('assets/')) ||
    request.url.endsWith('.json') ||
    request.url.includes('/maintenance/check') ||
    router.url === '/maintenance'
  ) {
    request = req.clone();
    return next(request).pipe(
      catchError((error: HttpErrorResponse) => {
        return handleError(error);
      }),
    );
  }

  // Check if already in maintenance mode (avoid redundant checks for POST requests)
  if (maintenanceService.isMaintenanceMode()) {
    return throwError(() => new Error('Application is under maintenance'));
  }

  // Check maintenance for POST requests only
  return maintenanceService.checkMaintenance().pipe(
    switchMap((maintenanceResponse) => {
      // Handle maintenance mode activation
      if (maintenanceResponse.maintenanceFlag) {
        maintenanceService.setMaintenanceMode(true);

        return throwError(
          () =>
            new Error('Application is under maintenance POST requests blocked'),
        );
      }

      // If not in maintenance mode, proceed with the request and add headers
      maintenanceService.setMaintenanceMode(false);

      if (environment.prototype) {
        let url = req.url;
        let config = configService.getConfig();

        if (
          url.includes(config.requestBaseUrl) ||
          url.includes(config.pdfBaseUrl)
        ) {
          // Convert API URL to static file name
          url = url
            .replace(config.requestBaseUrl, '')
            .replace(config.pdfBaseUrl, '');

          const key = getFileName(url);
          // if key doesnt exist, then continue with the flow.
          if (!key) {
            return next(request).pipe(
              catchError((error: HttpErrorResponse) => {
                return handleError(error);
              }),
            );
          }
          const fileUrl = `assets/data/temp/${key}.json`;
          const staticReq = req.clone({ url: fileUrl });
          return next(staticReq);
        }
      } else {
        request = req.clone({
          setHeaders: {
            'gi-session-id': uuidv4(),
            'gi-trace-id': uuidv4(),
          },
        });
      }

      return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
          return handleError(error);
        }),
      );
    }),
    catchError((error) => {
      return throwError(
        () => new Error('Error checking maintenance mode: ' + error.message),
      );
    }),
  );

  function getFileName(url): String {
    if (url.includes('uw/request?key=')) {
      const keyMatch = url.match(/key=([^&]+)/);
      const key = keyMatch ? keyMatch[1] : '';
      return key;
    }

    return undefined;
  }

  function handleError(error: HttpErrorResponse) {
    if (error.status === 401) {
      // Redirect to login or handle unauthorized access
    } else {
      // Handle other errors
      console.error('HTTP Error:', error);
    }
    return throwError(() => error);
  }
};
